import type { FC, PropsWithChildren } from 'react'

export type FCProps<C> = C extends FC<infer P> ? P : never

export type ReadonlyPropsWithChildren<T> = Readonly<PropsWithChildren<T>>
